var exports = {
  "qS": "MentionBadge.module__badge___U1dXX2",
  "ZN": "MentionBadge.module__badgeSmall___U1dXX2",
  "N1": "MentionBadge.module__badgeMedium___U1dXX2",
  "x5": "MentionBadge.module__animatedWrapper___U1dXX2",
};

module.exports = exports;
